module.exports = __webpack_public_path__ + "static/img/theme_active.a6470a79.svg";